import {
    SUBSCRIBERS_SUCCESS,
    SUBSCRIBERS_LOADING

} from '../actions/SubscribersAction';

const initialState = {
    subscribersData: null,
    isLoading: true,
};

const SubscribersReducer = (state = initialState, action = {}) => {
    switch (action.type) {
        case SUBSCRIBERS_SUCCESS:
            return { ...state, subscribersData: action.data, isLoading: false };

        case SUBSCRIBERS_LOADING:
            return { ...state, isLoading: action.isLoading };

        default:
            return state;
    }
};

export default SubscribersReducer;
